import Area from '@/components/Area';
import { useTexture } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import img1 from './Img1.jpg';
import img2 from './Img2.jpg';
import displacement10 from './displacement/10.jpg';
import displacement11 from './displacement/11.jpg';
import displacement12 from './displacement/12.jpg';
import displacement13 from './displacement/13.jpg';

function FadingImage() {
  const [textureImg1, textureImg2] = useTexture([
    img1.src,
    img2.src,
    displacement10.src,
    displacement11.src,
    displacement12.src,
    displacement13.src,
  ]);
  const [hovered, setHovered] = React.useState(false);
  // const ref = React.useRef<THREE.Mesh>(null);
  return (
    <mesh onPointerEnter={() => setHovered(true)} onPointerLeave={() => setHovered(false)}>
      <planeGeometry />
      <meshStandardMaterial map={hovered ? textureImg2 : textureImg1} />
    </mesh>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <Canvas camera={{ position: [0, 0, 2], fov: 50 }}>
          <ambientLight />
          <FadingImage />
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
